import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20b9ff4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stake-confirm-fee" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "stake-confirm-fee__title" }, "Network fee:", -1))
const _hoisted_3 = { class: "stake-confirm-fee__fiat" }
const _hoisted_4 = { class: "stake-confirm-fee__amount" }

import { GasFeeInfo } from "@/types/transaction";
import BigNumber from "bignumber.js";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'stake-confirm-fee',
  props: {
  fee: {
    type: Object as PropType<GasFeeInfo>,
    default: () => ({
      nativeValue: new BigNumber(0),
      fiatValue: new BigNumber(0),
      nativeSymbol: "dot",
      fiatSymbol: "USD",
    }),
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$filters.currencyFormat(__props.fee.fiatValue, __props.fee.fiatSymbol)), 1),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$filters.cryptoCurrencyFormat(__props.fee.nativeValue)), 1)
  ]))
}
}

})